var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAntiRacism = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Religion-Peace--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Religion Peace Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm1.8 20.3a0.23 0.23 0 0 1 -0.21 -0.05 0.22 0.22 0 0 1 -0.09 -0.19V14.2a0.24 0.24 0 0 1 0.15 -0.23 0.26 0.26 0 0 1 0.28 0l3.86 3.85a0.24 0.24 0 0 1 0.07 0.18 0.25 0.25 0 0 1 -0.08 0.18 8.43 8.43 0 0 1 -3.98 2.12Zm-0.23 -10.87a0.29 0.29 0 0 1 -0.07 -0.18V4a0.25 0.25 0 0 1 0.09 -0.2 0.27 0.27 0 0 1 0.21 0 8.55 8.55 0 0 1 6.7 8.2 8.65 8.65 0 0 1 -0.61 3.18 0.27 0.27 0 0 1 -0.18 0.15 0.27 0.27 0 0 1 -0.23 -0.07Zm-9 5.9a0.26 0.26 0 0 1 -0.21 0.07 0.3 0.3 0 0 1 -0.19 -0.14A8.69 8.69 0 0 1 3.5 12a8.53 8.53 0 0 1 6.7 -8.31 0.31 0.31 0 0 1 0.21 0.05 0.25 0.25 0 0 1 0.09 0.2v5.31a0.29 0.29 0 0 1 -0.07 0.18Zm5.5 -1.33a0.26 0.26 0 0 1 0.28 0 0.25 0.25 0 0 1 0.15 0.23v5.86a0.25 0.25 0 0 1 -0.3 0.24 8.51 8.51 0 0 1 -4 -2.06 0.25 0.25 0 0 1 -0.08 -0.18 0.2 0.2 0 0 1 0.07 -0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAntiRacism);
export default ForwardRef;